<div class="solutionsContactWrapper">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="contactUsTxt">
                    <h2>our solution</h2>
                    <h1>Add AI to your existing contact center technology.</h1>
                </div>
                <button><a href="#contactDetails">Contact us</a></button>
            </div>
        </div>
    </div>
</div>